import { gql } from "apollo-boost";
import { apolloClient, getApolloOptions } from "./apolloClient";

const GET_APPLICATION = gql`
  query Application($id: ID!){
    application (id: $id) {
      id
      type_for_xcube
      type_for_xpod
      type_for_xkiosk
      type_for_xtend
      repository
      experiences {
        name
      }
    }
  }
`;

const GET_APPLICATIONS = gql`
  query {
    applications (sort: "repository") {
      id
      type_for_xcube
      type_for_xpod
      type_for_xkiosk
      type_for_xtend
      repository
      x_cube_applications {
        id
        status
        version
        x_cube {
          id
        }
      }
    }
  }
`;

const GET_XCUBE_APPLICATIONS = gql`
  query ($limit: Int, $offset: Int, $applicationId: ID!) {
    xCubeApplications(
      where: { application: { id: $applicationId } }
      limit: $limit
      start: $offset
      sort: "id:asc"
    ) {
      id
      status
      version
      x_cube {
        id
        name
      }
    }
  }
`;

const GET_XCUBE_APPLICATION_FOR_XCUBE_APPLICATION = gql`
  query ($xcubeId: ID!, $applicationId: ID!) {
    xCubeApplications(
      where: { application: { id: $applicationId }, x_cube: { id: $xcubeId } }
    ) {
      id
      status
      version
      x_cube {
        id
        name
      }
    }
  }
`;

const DELETE_XCUBE_APPLICATION = gql`
    mutation ($id: ID!) {
        deleteXCubeApplication(input: { where: { id: $id } }) {
            xCubeApplication {
                id
            }
        }
    }`;

const DEACTIVATE_XCUBE_APPLICATION = gql`
    mutation ($id: ID!) {
        updateXCubeApplication(
            input: {
                where: { id: $id }
                data: { status: "inactive" }
            }
        ) {
            xCubeApplication {
                id
                status
            }
        }
    }
`;

export const getApplications = async () => {
    const res = await apolloClient.query({
        ...getApolloOptions(),
        query: GET_APPLICATIONS,
    });

    return res.data.applications;
};

export const getApplication = async (id) => {
    const res = await apolloClient.query({
        ...getApolloOptions(),
        query: GET_APPLICATION,
        variables: { id },
    });

    return res.data.application;
};

export const getXCubeApplications = async (applicationId) => {
    let result = [];
    let offset = 0;
    let page = [];
    do {
        const res = await apolloClient.query({
            ...getApolloOptions(),
            query: GET_XCUBE_APPLICATIONS,
            variables: { limit: 100, offset: offset, applicationId },
        });
        page = res.data.xCubeApplications;
        result = result.concat(page);
        offset += 100;
    } while (page.length === 100);

    return result;
}

export const getXCubeApplicationsForXCubeAndApplication = async (xcubeId, applicationId) => {
    const res = await apolloClient.query({
        ...getApolloOptions(),
        query: GET_XCUBE_APPLICATION_FOR_XCUBE_APPLICATION,
        variables: { xcubeId, applicationId },
    });

    return res.data.xCubeApplications;
}


export const deleteXCubeApplication = async (xcubeApplicationId) => {
    try {

        const res = await apolloClient.mutate({
            ...getApolloOptions(),
            mutation: DELETE_XCUBE_APPLICATION,
            variables: { id: xcubeApplicationId },
        });
    } catch (error) {
        console.error("Error deleting XCube Application:", error);
        return false;
    }
    return true;
};


export const deactivateXCubeApplication = async (xcubeApplicationId) => {
    try {

        const res = await apolloClient.mutate({
            ...getApolloOptions(),
            mutation: DEACTIVATE_XCUBE_APPLICATION,
            variables: { id: xcubeApplicationId },
        });
    } catch (error) {
        console.error("Error deactivating XCube Application:", error);
        return false;
    }
    return true;
};
